import { SpacingType } from "../../types";
import { SpacingEnum } from "../../components/Container/styles";

const spacingToPx = (spacing: SpacingType | number) =>
  typeof spacing === "number" ? `${spacing}px` : `${SpacingEnum[spacing]}px`;

export default spacingToPx;
